export enum ParamKey {
  promo = '',
  notFound = '**',
  textBook = 'textbook',
  team = 'team',
  games = 'games',
  wordConstructor = 'words-puzzle',
  statistics = 'statistics',
  savannaPromo = 'savanna',
  audiocallPromo = 'audiocall',
  audiocallGame = 'audiocallgame',
  sprintGame = 'sprint',
}

export enum QueryParamKey {
  redirectTo = '',
}
